class SpeakService {
  constructor() {
    // 检测支持
    this.supported = typeof window !== 'undefined' && 'speechSynthesis' in window
    if (!this.supported) {
      console.warn('当前浏览器不支持语音合成')
      return
    }

    this.synth = window.speechSynthesis
    this.ready = false
    this.pending = [] // 仅在未就绪时暂存文本，就绪后自动清空

    // 加载语音（iOS 需要异步获取）
    const loadVoices = () => {
      if (this.synth.getVoices().length > 0) {
        this.ready = true
        // 播放所有暂存的文本
        while (this.pending.length) {
          this._speak(this.pending.shift())
        }
      } else {
        // 等待语音加载完成
        setTimeout(loadVoices, 100)
      }
    }
    loadVoices()
  }

  _speak(text) {
    const utterance = new SpeechSynthesisUtterance(text)
    utterance.lang = 'zh-CN'
    utterance.volume = 1
    utterance.rate = 1
    utterance.pitch = 1
    this.synth.speak(utterance)
  }

  speak(text) {
    if (!this.supported) return
    if (this.ready) {
      this._speak(text)
    } else {
      // 未就绪时暂存，等待语音加载完成后自动播放
      this.pending.push(text)
    }
  }
}

const speakService = new SpeakService()
export default speakService